import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    height: '28px',
  },
  leftContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: theme.spacing(2),
  },
  btnDisabled: {
    pointerEvents: 'none',
    opacity: '39%',
  },
  moreMenu: {
    color: theme.palette.select.light,
  },
  modalText: {
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '20px',
    letterSpacing: '0.25px',
    color: theme.palette.labraText.description,
    fontFamily: theme.typography.fontFamily,
    textAlign: 'left',
    width: theme.spacing(52.5),
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1.5),
    '& p': {
      margin: 0,
    },
  },
  descriptionNote: {
    fontWeight: 600,
    fontSize: '14px',
  },
  rowRightItem: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    width: '100%',
    gap: theme.spacing(2),
    padding: theme.spacing(5, 1, 0, 0),
    height: theme.spacing(5),
  },
}))
